import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_DESCARGADOS } from '../../../../../../config/tables'

export default function TablaCamionesDescargadosView () {
  return <MuiTable id={TABLA_CAMIONES_DESCARGADOS} />
}
